import React, { useMemo, useState } from 'react'
import { ILightRailItem } from '../../../types'
import { RailItemImage, RailItemImageWrap } from './RailItemMain.style'
import { useRouter } from 'next/router'
import { ottUtils } from '../ottUtils'
import { RailItemWrap } from '../RailItem/RailItem.style'

export const RailItemMain = ({
  data,
  isLast,
  isFirst,
}: {
  data: ILightRailItem
  isLast: boolean
  isFirst: boolean
}) => {
  const router = useRouter()
  const [loaded, setLoaded] = useState(false)
  const imgUrl = useMemo(() => {
    let img = data?.images.find(i => i.imageTypeName === '16x9')
    if (!img) {
      img = data?.images[0]
    }
    return img.url + '/width/288/height/153/'
  }, [data?.images])
  const _click = () => {
    router.push(ottUtils.getAssetPath(data))
  }

  const classList = useMemo(() => {
    if (isFirst) {
      return 'first'
    }
    if (isLast) {
      return 'last'
    }
    return ''
  }, [isFirst, isLast])

  return (
    <RailItemWrap onClick={_click} className={classList}>
      <RailItemImageWrap theme={{ loaded: loaded, type: data.typeDescription }}>
        {data?.images[0]?.url && (
          <RailItemImage
            onLoad={() => setLoaded(true)}
            loading='lazy'
            src={imgUrl}
            alt='Image description'
          />
        )}
      </RailItemImageWrap>
    </RailItemWrap>
  )
}
